import React from "react";
import { Route } from "react-router-dom";
import Page from "@ROM-pages/CompanyAdmin/Warehouses/Edit";
import Layout from "@ROM-pages/Layouts/CompanyAdmin";

class RouteHandler extends Route {
  render() {
    return (
      <Layout>
        <Page warehouseId={this.props.computedMatch.params.warehouseId} />
      </Layout>
    );
  }
}

export default RouteHandler;
